import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const ConfirmModal = ({ 
  isOpen, 
  show, 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  onClose,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  type = "success",
  danger 
}) => {
  const modalOpen = isOpen || show;
  const handleCancel = onCancel || onClose;
  const isDanger = danger || type === "danger";
  
  if (!modalOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded shadow-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-bold mb-2">{title}</h3>
        <p className="mb-4">{message}</p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="px-4 py-2 rounded bg-gray-400 text-white font-semibold shadow hover:bg-gray-500 focus:outline-none"
            onClick={handleCancel}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={`px-4 py-2 rounded font-semibold shadow focus:outline-none ${isDanger ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'} text-white`}
            onClick={onConfirm}
          >
            <FontAwesomeIcon icon={faCheck} />
            <span className="ml-1">{confirmText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
